import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const SettingService = {
  // Define your API functions here
  getList: async () => {
    const response = await apiService.get("/sections");
    return response.data;
  },
  createPrintToken: async () => {
    const response = await apiService.post("/auth/generateprinttoken");
    return response.data;
  },

  detail: async (id) => {
    const response = await apiService.get(`/sections/${id}`);
    return response.data;
  },
  delete: async (id) => {
    const response = await apiService.delete(`/sections/${id}`);
    return response.data;
  },
  update: async (id, updatedData) => {
    try {
      const response = await apiService.put(`/sections/${id}`, updatedData);
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },

  getDaySetting: async () => {
    const response = await apiService.get("/generalsettings/daysettings");
    return response.data;
  },

  setOpenDay: async () => {
    const response = await apiService.get(
      "/generalsettings/daysettings/set-open"
    );
    return response.data;
  },
};

export default SettingService;
